const Modal = ({ children, status, close }) => {
  const active = status ? '-active' : '-inactive'
  return (
    <>
      <div className={`modal-back${active}`} onClick={close} />
      <div className={`modal${active}`}>
        <div>{children}</div>
      </div>
    </>
  )
}

export default Modal
